export default __webpack_public_path__ + "static/how-to-get-started-buyer-b7732a5e6f7f903a23c3987c1bbb93b3.jpeg";